// extracted by mini-css-extract-plugin
export default {"cuadroFiltros":"BotoneraFiltros_cuadroFiltros__a5RtD","filtro":"BotoneraFiltros_filtro__HWMaq","selected":"BotoneraFiltros_selected__GYfJy"};